/* NOSEKNOWS status-check (案A: 署名URL方式)
   - POST /apps/nk/status-link/request
   - honeypot + _t (3秒未満はbot判定)
   - 送信後はフォーム非表示 → 完了メッセージ + RESEND(60秒クールダウン)
*/
(function () {
  "use strict";

  var ENDPOINT = "/apps/nk/status-link/request";
  var MIN_ELAPSED_SEC = 3;
  var RESEND_COOLDOWN_SEC = 60;

  function init() {
    var form = document.getElementById("nk-status-check-form");
    if (!form) return;

    var tsField = form.querySelector("[data-nk-ts]");
    var hpField = form.querySelector("[data-nk-hp]");
    var emailField = form.querySelector("[data-nk-email]");
    var btn = form.querySelector("[data-nk-status-check-btn]");
    var msgEl = form.querySelector("[data-nk-status-check-msg]");
    var sentBlock = document.getElementById("nk-status-sent");
    var resendBtn = document.getElementById("nk-status-resend-btn");
    var resendStatus = document.getElementById("nk-status-resend-status");

    if (!tsField || !emailField || !btn || !msgEl || !sentBlock) return;

    tsField.value = Math.floor(Date.now() / 1000);

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // honeypot: 静かに成功表示へ
      if (hpField && hpField.value !== "") {
        showSent(form, sentBlock, resendBtn);
        return;
      }

      var elapsed = Math.floor(Date.now() / 1000) - parseInt(tsField.value, 10);
      if (elapsed < MIN_ELAPSED_SEC) {
        showError(msgEl, "少しお待ちください");
        return;
      }

      var email = (emailField.value || "").trim();
      if (!email || !isValidEmail(email)) {
        showError(msgEl, "メールアドレスの形式が正しくありません");
        return;
      }

      if (btn.disabled) return;
      setBtnLoading(btn, true);
      clearMsg(msgEl);

      sendRequest(email, hpField ? hpField.value : "", parseInt(tsField.value, 10))
        .then(function (data) {
          // 成功 → フォーム非表示、送信済みUI
          if (data.ok) {
            showSent(form, sentBlock, resendBtn);
            startCooldown(resendBtn, resendStatus);
          } else {
            handleError(data.error, msgEl);
            setBtnLoading(btn, false);
          }
        })
        .catch(function () {
          showError(msgEl, "通信エラーが発生しました。時間をおいて再度お試しください。");
          setBtnLoading(btn, false);
        });
    });

    if (resendBtn) {
      resendBtn.addEventListener("click", function () {
        if (resendBtn.disabled) return;

        var email = (emailField.value || "").trim();
        if (!email || !isValidEmail(email)) {
          if (resendStatus) resendStatus.textContent = "メールアドレスの形式が正しくありません";
          return;
        }

        resendBtn.disabled = true;
        resendBtn.textContent = "送信中...";
        if (resendStatus) resendStatus.textContent = "";

        // 再送は_tを現在時刻で再設定 (3秒制限はクールダウンで十分クリア)
        sendRequest(email, hpField ? hpField.value : "", Math.floor(Date.now() / 1000))
          .then(function (data) {
            if (data.ok) {
              if (resendStatus) {
                resendStatus.style.color = "var(--c1)";
                resendStatus.textContent = "再送しました。受信箱をご確認ください。";
              }
              startCooldown(resendBtn, resendStatus);
            } else {
              if (resendStatus) {
                resendStatus.style.color = "var(--c2)";
                resendStatus.textContent = errorMessage(data.error);
              }
              resendBtn.disabled = false;
              resendBtn.textContent = "RESEND / 再送";
            }
          })
          .catch(function () {
            if (resendStatus) {
              resendStatus.style.color = "var(--c2)";
              resendStatus.textContent = "通信エラーが発生しました。";
            }
            resendBtn.disabled = false;
            resendBtn.textContent = "RESEND / 再送";
          });
      });
    }
  }

  function sendRequest(email, hp, ts) {
    var payload = {
      email: email,
      hp_field: hp,
      _t: ts
    };
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function showSent(form, sentBlock, resendBtn) {
    form.style.display = "none";
    sentBlock.style.display = "";
    if (resendBtn) {
      resendBtn.disabled = false;
      resendBtn.textContent = "RESEND / 再送";
    }
  }

  function startCooldown(btn, statusEl) {
    if (!btn) return;
    var remaining = RESEND_COOLDOWN_SEC;
    btn.disabled = true;
    btn.textContent = "RESEND / 再送 (" + remaining + ")";
    var timer = setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        clearInterval(timer);
        btn.disabled = false;
        btn.textContent = "RESEND / 再送";
        if (statusEl && statusEl.textContent === "") {
          // no-op
        }
      } else {
        btn.textContent = "RESEND / 再送 (" + remaining + ")";
      }
    }, 1000);
  }

  function handleError(code, msgEl) {
    showError(msgEl, errorMessage(code));
  }

  function errorMessage(code) {
    var messages = {
      "INVALID_EMAIL": "メールアドレスの形式が正しくありません",
      "RATE_LIMITED": "送信回数が多すぎます。時間をおいて再度お試しください。"
    };
    return messages[code] || "送信に失敗しました。時間をおいて再度お試しください。";
  }

  function showError(el, text) {
    el.innerHTML = "";
    el.textContent = text;
    el.style.color = "var(--c2)";
    el.style.display = "block";
  }

  function clearMsg(el) {
    el.innerHTML = "";
    el.style.display = "none";
  }

  function setBtnLoading(btn, loading) {
    if (loading) {
      btn.disabled = true;
      btn.dataset.originalLabel = btn.textContent;
      btn.textContent = "送信中...";
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalLabel || "SEND / 送信";
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
